"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = _interopRequireDefault(require("@/views/user/index.vue"));
var _role = _interopRequireDefault(require("@/views/permission/role.vue"));
var SettingPage = /*#__PURE__*/function (_Vue) {
  function SettingPage() {
    (0, _classCallCheck2.default)(this, SettingPage);
    return (0, _callSuper2.default)(this, SettingPage, arguments);
  }
  (0, _inherits2.default)(SettingPage, _Vue);
  return (0, _createClass2.default)(SettingPage);
}(_vuePropertyDecorator.Vue);
SettingPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    StaffPage: _index.default,
    RolePage: _role.default
  }
})], SettingPage);
var _default = exports.default = SettingPage;